import { connect } from 'react-redux'
import Draggable from 'react-draggable'
import { triggerDebugPopup } from '../../redux/actions'
import { popupTriggerer } from '../../redux/constants'


@connect(state => ({
  showPopupTriggerer: state.base.showPopupTriggerer
}), { triggerDebugPopup })
export default class PopupTriggerer extends React.Component {
  constructor() {
    super()
  }

  triggerPopup = (type) => {
    this.props.triggerDebugPopup({ type })
  }

  render() {
    const { showPopupTriggerer } = this.props

    return (
      <Draggable handle={".handle"}>
        <div id="popupTriggerTool" style={{ display: showPopupTriggerer ? 'block' : 'none' }}>
          <div className="handle">Drag</div>
          <div className="title">Popup Debugger</div>
          <div className="popupChoices">
            <input type="button" value="Normal Error" onClick={() => this.triggerPopup(popupTriggerer.NORMAL_ERROR)} />
            <input type="button" value="Custom Error" onClick={() => this.triggerPopup(popupTriggerer.CUSTOM_ERROR)} />
            <input type="button" value="Sound Prompt" onClick={() => this.triggerPopup(popupTriggerer.SOUND_PROMPT)} />
            <input type="button" value="Game restore" onClick={() => this.triggerPopup(popupTriggerer.GAME_RESTORE)} />
            <input type="button" value="Home prompt" onClick={() => this.triggerPopup(popupTriggerer.HOME_PROMPT)} />
            <input type="button" value="Reality Check" onClick={() => this.triggerPopup(popupTriggerer.REALITY_CHECK)} />
            <input type="button" value="Quick Spin" onClick={() => this.triggerPopup(popupTriggerer.QUICK_SPIN)} />
            <input type="button" value="Login Popup" onClick={() => this.triggerPopup(popupTriggerer.MESSAGE_WITH_LOGIN)} />
            <input type="button" value="Jackpot Won" onClick={() => this.triggerPopup(popupTriggerer.JACKPOT_WON)} />
            <input type="button" value="Free rounds v1" onClick={() => this.triggerPopup(popupTriggerer.FREE_ROUNDS)} />
            <input type="button" value="Free rounds End" onClick={() => this.triggerPopup(popupTriggerer.FREE_ROUNDS_END)} />
            <input type="button" value="Free rounds v2" onClick={() => this.triggerPopup(popupTriggerer.FREE_ROUNDS_V2)} />
          </div>
        </div>
      </Draggable>
    )
  }
}
